import { useState } from "react";
import { Button, Input, Popover, Space } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useAreas, useSaveState, useUndoRedo } from "../../../hooks";
import {
  Action,
  ObjectType,
  State,
  defaultBlue,
} from "../../../data/constants";
import ColorPalette from "../../ColorPicker";
import { useTranslation } from "react-i18next";

export default function AreaInfo({ data, i }) {
  const { t } = useTranslation();
  const { setSaveState } = useSaveState();
  const { deleteArea, updateArea } = useAreas();
  const { setUndoStack, setRedoStack } = useUndoRedo();
  const [editField, setEditField] = useState({});

  return (
    <div
      id={`scroll_area_${data.id}`}
      className="my-3"
    >
      <Space align="center" className="w-full">
        <div className="flex-1">
          <Input
            value={data.name}
            placeholder={t("name")}
            onChange={(e) => updateArea(data.id, { name: e.target.value })}
            onFocus={(e) => setEditField({ name: e.target.value })}
            onBlur={(e) => {
              if (e.target.value === editField.name) return;
              setUndoStack((prev) => [
                ...prev,
                {
                  action: Action.EDIT,
                  element: ObjectType.AREA,
                  aid: i,
                  undo: editField,
                  redo: { name: e.target.value },
                  message: t("edit_area", {
                    areaName: e.target.value,
                    extra: "[name]",
                  }),
                },
              ]);
              setRedoStack([]);
            }}
          />
        </div>
        <Popover
          content={
            <div className="popover-theme">
              <ColorPalette
                currentColor={data.color}
                onClearColor={() => {
                  updateArea(i, { color: defaultBlue });
                  setSaveState(State.SAVING);
                }}
                onPickColor={(c) => {
                  setUndoStack((prev) => [
                    ...prev,
                    {
                      action: Action.EDIT,
                      element: ObjectType.AREA,
                      aid: i,
                      undo: { color: data.color },
                      redo: { color: c },
                      message: t("edit_area", {
                        areaName: data.name,
                        extra: "[color]",
                      }),
                    },
                  ]);
                  setRedoStack([]);
                  updateArea(i, { color: c });
                }}
              />
            </div>
          }
          trigger="click"
          placement="bottomLeft"
          arrow
        >
          <div
            className="h-[32px] w-[32px] rounded cursor-pointer"
            style={{ backgroundColor: data.color }}
          />
        </Popover>
        <Button
          icon={<DeleteOutlined />}
          danger
          onClick={() => deleteArea(i, true)}
        />
      </Space>
    </div>
  );
}
